import * as React from 'react';
import SearchIcon from './assets/SearchIcon.svg';
import './index.scss';

export interface FilterProps {
  onChange: (e: string) => void;
}

export default class Filter extends React.Component<FilterProps, any> {
  public onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    this.props.onChange(e.target.value.trim().toLowerCase());

  public render() {
    return (
      <div className="Filter">
        <input type="text" onChange={this.onChange} placeholder="Search by year or name" />
        <img src={SearchIcon} />
      </div>
    );
  }
}
